import { PartRelationshipNode, PartRelationshipNodeType } from '@/api/generatedApi';

export type NodeActionKey =
  | 'open-report'
  | 'run-report'
  | 'show-supplier'
  | 'open-website'
  | 'copy'
  | 'focus'
  | 'show-all';

export interface NodeAction {
  key: NodeActionKey;
  label: string;
}

const COPY_LABELS: Record<PartRelationshipNodeType, string> = {
  [PartRelationshipNodeType.Nsn]: 'Copy NSN',
  [PartRelationshipNodeType.PartNumber]: 'Copy part number',
  [PartRelationshipNodeType.Cage]: 'Copy CAGE',
  [PartRelationshipNodeType.EndItem]: 'Copy end item',
  [PartRelationshipNodeType.Supplier]: 'Copy supplier name',
};

const reportActions = (node: PartRelationshipNode, isSeed: boolean): NodeAction[] => {
  if (isSeed) return [];
  if (node.type === PartRelationshipNodeType.PartNumber) {
    return [{ key: 'run-report', label: 'Run report for this part number' }];
  }
  if (node.type !== PartRelationshipNodeType.Nsn) return [];
  const runReport: NodeAction = { key: 'run-report', label: node.reportId ? 'Run new report' : 'Run report' };
  return node.reportId ? [{ key: 'open-report', label: 'Open saved report' }, runReport] : [runReport];
};

const supplierActions = (node: PartRelationshipNode): NodeAction[] => {
  const actions: NodeAction[] = [];
  if (node.sourcingOpportunityId) actions.push({ key: 'show-supplier', label: 'Show in Sourcing Opportunities' });
  if (node.url && /^https?:\/\//i.test(node.url)) actions.push({ key: 'open-website', label: 'Open supplier website' });
  return actions;
};

export const nodeActions = (node: PartRelationshipNode, isSeed: boolean, isFocused: boolean): NodeAction[] => [
  ...reportActions(node, isSeed),
  ...supplierActions(node),
  { key: 'copy', label: COPY_LABELS[node.type] },
  isFocused ? { key: 'show-all', label: 'Show all relationships' } : { key: 'focus', label: 'Focus on this node' },
];
